import { Action } from '../types'
import React, { useState } from 'react'
import { convertUserInputToFilterValues } from '../utility'
import { Box, Button, TextField } from '@mui/material'

export function BodyUpdate({
  action,
  onActionChange,
}: {
  action?: Action
  onActionChange: (action?: Action) => void
}) {
  const [newKey, setNewKey] = useState('')
  const [newVal, setNewVal] = useState('')

  const data = (action?.actionType === 'bodyUpdate' && action.data) || {}

  const disableAdd = !newKey || !newVal
  const onAdd = () => {
    if (disableAdd) return
    const newValue = convertUserInputToFilterValues(newVal).pop()
    switch (typeof newValue) {
      case 'string':
      case 'number':
      case 'boolean': {
        onActionChange({
          actionType: 'bodyUpdate',
          data: {
            ...data,
            [newKey]: newValue,
          },
        })
        setNewKey('')
        setNewVal('')
      }
    }
  }

  const removeKey = (key: string) => {
    delete data[key]
    onActionChange({
      actionType: 'bodyUpdate',
      data,
    })
  }

  return (
    <Box>
      <Box>Update Body</Box>
      <Box padding="5px" borderRadius="5px" border="solid 1px">
        <Box>Current Values</Box>
        <Box padding="5px">
          {Object.entries(data).map(([key, value]) => {
            return (
              <Box key={key}>
                {key}: {`${String(value)} (${typeof value})`}
                <Button onClick={() => removeKey(key)}>Remove</Button>
              </Box>
            )
          })}
        </Box>
      </Box>
      <Box padding="5px">
        <Box>New Body Update</Box>
        <Box padding="5px">
          <TextField
            onChange={({ target: { value } }) => setNewKey(value)}
            value={newKey}
            label="New Key"
          />
          <TextField
            onChange={({ target: { value } }) => setNewVal(value)}
            value={newVal}
            label="New Value"
          />
          <Button onClick={onAdd} disabled={disableAdd}>
            Add
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
